import { render } from "./DocumentEditionPage.vue?vue&type=template&id=15610640&scoped=true"
import script from "./DocumentEditionPage.vue?vue&type=script&lang=js"
export * from "./DocumentEditionPage.vue?vue&type=script&lang=js"

import "./DocumentEditionPage.vue?vue&type=style&index=0&id=15610640&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15610640"]])

export default __exports__